import React from "react"
import SimpleTimeEditor from "../../common/SimpleTimeEditor"
import { IScheduleDailyTimelineData, ISimpleTime, IScheduleShift } from "../../../models"
import * as utils from "../../../helpers/utils"
import autobind from "class-autobind"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
interface IProps {
    leftCoordinate: boolean
    timelineItem: IScheduleDailyTimelineData
}
interface IState {
    startTime: ISimpleTime
    endTime: ISimpleTime
}

export default class TimelineItemQuickEditTime extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            startTime: this.props.timelineItem.StartTime,
            endTime: this.props.timelineItem.EndTime
        }
        autobind(this)
    }

    handleChange(startTime: ISimpleTime, endTime: ISimpleTime) {
        const virtualTimes = scheduleHelper.getVirtualShiftTime(startTime, endTime)
        const virtualTimePayload = {
            StartTime: virtualTimes.VirtualStartTime,
            EndTime: virtualTimes.VirtualEndTime,
            Breaks: []
        } as IScheduleShift
        const realShiftStartDateTime = scheduleHelper.getTimeFromSimpleTime(this.props.timelineItem.StartTime).format()
        const realTimePayload = scheduleHelper.getRealShiftTemplateFromVirtualShiftTemplate(realShiftStartDateTime, virtualTimePayload)
        this.setState({ startTime: realTimePayload.StartTime, endTime: realTimePayload.EndTime })
    }

    render() {
        const readonlyStartTime = this.props.timelineItem.PunchedIn ? true : false
        const readonlyEndTime = this.props.timelineItem.PunchedOut ? true : false
        return (
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    backgroundColor: utils.getMaterial900ColorFrom500Color(this.props.timelineItem.Color),
                    minWidth: 200,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    left: this.props.leftCoordinate && 0,
                    right: !this.props.leftCoordinate && 0
                }}
            >
                <div>
                    <SimpleTimeEditor
                        autoFocus={!readonlyStartTime}
                        readonly={readonlyStartTime}
                        simpleTime={this.state.startTime}
                        textFieldStyle={{ fontSize: 13, color: "white" }}
                        semicolonColor="white"
                        handleChange={startTime => this.handleChange(startTime, this.state.endTime)}
                    />
                </div>
                <div style={{ marginLeft: 25 }}>
                    <SimpleTimeEditor
                        autoFocus={readonlyStartTime && !readonlyEndTime}
                        readonly={readonlyEndTime}
                        simpleTime={this.state.endTime}
                        textFieldStyle={{ fontSize: 13, color: "white" }}
                        semicolonColor="white"
                        handleChange={endTime => this.handleChange(this.state.startTime, endTime)}
                    />
                </div>
            </div>
        )
    }
}
